// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1q0Xn","input":"Checkbox_input__1vFEZ","inner":"Checkbox_inner__9jk01","tick":"Checkbox_tick__33zKN","text":"Checkbox_text__1IDPW"};